import { RefreshResult } from "@idw-types/common";

export enum AxnAdminConfigActionTypes {
    SET_AXN_ADMIN_CONFIG_REFRESHING = "SET_AXN_ADMIN_CONFIG_REFRESHING",
    SET_AXN_ADMIN_CONFIG_REFRESH_RESULTS = "SET_AXN_ADMIN_CONFIG_REFRESH_RESULTS"
}

type SetAxnAdminConfigRefreshingAction = {
    type: AxnAdminConfigActionTypes.SET_AXN_ADMIN_CONFIG_REFRESHING,
    payload: { isRefreshing: boolean; }
};

export const setAxnAdminConfigRefreshing = (isRefreshing: boolean): SetAxnAdminConfigRefreshingAction => ({
    type: AxnAdminConfigActionTypes.SET_AXN_ADMIN_CONFIG_REFRESHING,
    payload: { isRefreshing }
});

type SetAxnAdminConfigRefreshResultAction = {
    type: AxnAdminConfigActionTypes.SET_AXN_ADMIN_CONFIG_REFRESH_RESULTS,
    payload: { refreshResults: Array<RefreshResult>; lastRefreshDate: Date; }
}

export const setAxnAdminConfigRefreshResults = (refreshResults: Array<RefreshResult>, lastRefreshDate: Date): SetAxnAdminConfigRefreshResultAction => ({
    type: AxnAdminConfigActionTypes.SET_AXN_ADMIN_CONFIG_REFRESH_RESULTS,
    payload: { refreshResults, lastRefreshDate }
});


export type AxnAdminConfigActions =
    SetAxnAdminConfigRefreshingAction |
    SetAxnAdminConfigRefreshResultAction